import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import PresentTextField from '../../../components/inputs/PresentTextField';

import { updateMyProfile } from '../../../actions/authActions';

const styles = {
  card: {
    marginBottom: '1.5rem'
  },
  inputWrapper: {
    paddingX: '0.5rem'
  },
  contact: {
    py: '1rem'
  }
}

const ProfileForm = () => {
  const dispatch = useDispatch();
  const current = useSelector(state => state.auth.profile);

  const [user, setUser] = useState({
    email: '',
    name: '',
    address: '',
    city: '',
    phoneNumber: '',
    taxType: '',
    nit: '',
    contactName: '',
    contactPhoneNumber: '',
    contactEmail: '',
  });

  useEffect(() => {
    setUser(prev => ({ ...prev, ...current }));
  }, [current])

  const handleChange = e => setUser(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = e => {
    e?.preventDefault();
    dispatch(updateMyProfile({ user }));
  }

  return (
    <Card>
      <CardHeader title="Datos de la cuenta" />
      <CardContent>
        <Grid container>
        <Grid item xs={12} sx={styles.inputWrapper}>
            <PresentTextField label="Correo electrónico" name="email" value={user.email} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} sx={styles.inputWrapper}>
            <PresentTextField label="Nombre" name="name" value={user.name} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="NIT" name="nit" value={user.nit} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Ciudad" name="city" value={user.city} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} md={12} sx={styles.inputWrapper}>
            <PresentTextField label="Dirección" name="address" value={user.address} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Teléfono móvil" name="phoneNumber" value={user.phoneNumber} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} md={6} sx={styles.inputWrapper}>
            <PresentTextField label="Tipo de contribuyente" name="taxType" value={user.taxType} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} sx={styles.contact}>
            <Typography variant="h6">Datos de contacto</Typography>
          </Grid>
          <Grid item xs={12} md={4} sx={styles.inputWrapper}>
            <PresentTextField label="Nombre de contacto" name="contactName" value={user.contactName} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} md={4} sx={styles.inputWrapper}>
            <PresentTextField label="Correo de contacto" name="contactEmail" value={user.contactEmail} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} md={4} sx={styles.inputWrapper}>
            <PresentTextField label="Teléfono de contacto" name="contactPhoneNumber" value={user.contactPhoneNumber} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button color="primary" onClick={handleSubmit}>Guardar</Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default ProfileForm;
